import { render, staticRenderFns } from "./robot-add.vue?vue&type=template&id=b70f130a&scoped=true&"
import script from "./robot-add.vue?vue&type=script&lang=js&"
export * from "./robot-add.vue?vue&type=script&lang=js&"
import style0 from "./robot-add.vue?vue&type=style&index=0&id=b70f130a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70f130a",
  null
  
)

export default component.exports